import { ITAppContactArgs, TAppContact } from 'TProtocol/common/models';
import { UAppAddress, UAppEmail, UAppPhone, UAppThirdPartyId } from './AugmentedClasses';

/* Class that extends TAppContact and uses the classes from AugmentedClasses, which have a _key property in addition
 * to everything else. This is a uuid, which is needed for keys when rendering in a form to properly track each
 * sub-object in React. */

export class UAppContact extends TAppContact {
  isUAppContact?: boolean;

  primaryMobile?: UAppPhone;
  personalMobile?: UAppPhone;
  personalLandline?: UAppPhone;
  professionalMobile?: UAppPhone;
  professionalLandline?: UAppPhone;
  otherPhones?: Array<UAppPhone>;

  personalEmail?: UAppEmail;
  professionalEmail?: UAppEmail;
  otherEmails?: Array<UAppEmail>;

  personalAddress?: UAppAddress;
  professionalAddress?: UAppAddress;
  otherAddresses?: Array<UAppAddress>;

  personalThirdPartyIds?: Array<UAppThirdPartyId>;
  professionalThirdPartyIds?: Array<UAppThirdPartyId>;
  otherThirdPartyIds?: Array<UAppThirdPartyId>;

  constructor(args?: ITAppContactArgs) {
    super(args);
    this.isUAppContact = true;

    if (this.primaryMobile) {
      this.primaryMobile = new UAppPhone(this.primaryMobile);
    }
    if (this.personalMobile) {
      this.personalMobile = new UAppPhone(this.personalMobile);
    }
    if (this.personalLandline) {
      this.personalLandline = new UAppPhone(this.personalLandline);
    }
    if (this.professionalMobile) {
      this.professionalMobile = new UAppPhone(this.professionalMobile);
    }
    if (this.professionalLandline) {
      this.professionalLandline = new UAppPhone(this.professionalLandline);
    }
    if (this.otherPhones) {
      this.otherPhones = this.otherPhones.map(phone => new UAppPhone(phone));
    }

    if (this.personalEmail) {
      this.personalEmail = new UAppEmail(this.personalEmail);
    }
    if (this.professionalEmail) {
      this.professionalEmail = new UAppEmail(this.professionalEmail);
    }
    if (this.otherEmails) {
      this.otherEmails = this.otherEmails.map(email => new UAppEmail(email));
    }

    if (this.personalAddress) {
      this.personalAddress = new UAppAddress(this.personalAddress);
    }
    if (this.professionalAddress) {
      this.professionalAddress = new UAppAddress(this.professionalAddress);
    }
    if (this.otherAddresses) {
      this.otherAddresses = this.otherAddresses.map(address => new UAppAddress(address));
    }

    if (this.personalThirdPartyIds) {
      this.personalThirdPartyIds = this.personalThirdPartyIds.map(tpi => new UAppThirdPartyId(tpi));
    }
    if (this.professionalThirdPartyIds) {
      this.professionalThirdPartyIds = this.professionalThirdPartyIds.map(tpi => new UAppThirdPartyId(tpi));
    }
    if (this.otherThirdPartyIds) {
      this.otherThirdPartyIds = this.otherThirdPartyIds.map(tpi => new UAppThirdPartyId(tpi));
    }
  }
}
